import React, { useState } from 'react'
import css from 'styled-jsx/css'
import { motion } from 'framer-motion'
import { EmailCaptureSubmit, EmailCaptureThanks } from './'
const { className, styles } = css.resolve`
	div {
		overflow: hidden;
		height: 35px;
		width: 280px;
		margin-bottom: 1.25rem;
		border: 1px solid black;
		border-radius: 50px;
		margin: 0 0.625rem;
		flex-direction: column;
		align-items: center;
	}
	input {
		border: none;
		padding: 0.625rem;
		font-size: var(--font--xs);
		height: 35px;
		width: 100%;
		background-color: transparent;
		outline: none;
	}
	input:focus {
		outline: none;
	}
	input::placeholder {
		color: rgba(0, 0, 0, 0.4);
	}
`

const EmailCaptureTitle = ({}) => {
	const [value, setValue] = useState('')
	const [submitted, setSubmitted] = useState(false)
	const handleChange = (e) => {
		setValue(e.target.value)
	}
	const handleSubmit = () => {
		alert(`This will submit the email (${value}) when done`)
		setSubmitted(true)
	}
	return (
		<>
			<div className="container">
				<motion.div
					animate={{
						width: submitted ? 100 : 280,
						backgroundColor: submitted ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0)',
					}}
					className={className}
				>
					<EmailCaptureThanks submitted={submitted} />
					<motion.input
						initial={false}
						animate={{ y: submitted ? 35 : -35 }}
						className={className}
						type="text"
						value={value}
						placeholder={'example@email.com'}
						onChange={handleChange}
					/>
				</motion.div>
				<EmailCaptureSubmit onSubmit={handleSubmit} submitted={submitted} />
			</div>
			{styles}
			<style jsx>{`
				.container {
					display: flex;
				}
			`}</style>
		</>
	)
}

export default EmailCaptureTitle
